import { render, staticRenderFns } from "./wsDropdownHeader.vue?vue&type=template&id=059a1445&scoped=true&"
import script from "./wsDropdownHeader.vue?vue&type=script&lang=js&"
export * from "./wsDropdownHeader.vue?vue&type=script&lang=js&"
import style0 from "./wsDropdownHeader.vue?vue&type=style&index=0&id=059a1445&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059a1445",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VHover,VIcon})
